import { z } from "zod";

const OccupancyYearlyReportDataV4Schema = z.object({
    year: z.number(),
    property_id: z.string().nullable(),
    occupancy: z.string(),
});

export const OccupancyYearlyReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(OccupancyYearlyReportDataV4Schema),
});

export type OccupancyYearlyReportDataV4 = z.infer<typeof OccupancyYearlyReportDataV4Schema>;
export type OccupancyYearlyReportResponseV4 = z.infer<typeof OccupancyYearlyReportResponseV4Schema>;